// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/physics.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/chemistry.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../images/zoology.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../images/botnay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../images/maths.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.physics_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chemistry_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.zoology_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.botnay_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.maths_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.bookmarks_section .type-wise-list .signle_card .card-header .icon i {
  font-size: 2rem;
}
.bookmarks_section .type-wise-list .signle_card .card-header .card-title {
  font-size: 1rem;
}
.bookmarks_section .type-wise-list .signle_card .card-body .card-title {
  font-size: 2rem;
}
.bookmarks_section a {
  text-decoration: none;
}
.bookmarks_section a .singlecard {
  height: 80px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  flex-direction: row;
  margin-bottom: 1rem;
}
.bookmarks_section a .singlecard::before {
  background: hsla(0, 0%, 0%, 0.6);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
}
.bookmarks_section a .singlecard .bg-img {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  filter: blur(2px);
}
.bookmarks_section a .singlecard .content {
  color: #ffffff;
  position: relative;
  z-index: 2;
}
.bookmarks_section a .singlecard .content .icon {
  text-align: center;
  display: block;
  line-height: 60px;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  color: #ffffff;
}
.bookmarks_section a .singlecard .content .icon svg {
  height: 45px;
}
.bookmarks_section .tags-list {
  margin: 0;
  padding: 0;
}
.bookmarks_section .tags-list li {
  font-size: 13px;
  padding: 0.2rem 1rem;
  margin-bottom: 10px;
  border-radius: 30px;
  background: #e0e0e0;
}
.bookmarks_section .tags-list li a {
  color: #212529;
  text-decoration: none;
}

.bookmark-header {
  position: relative;
  padding: 25px 0 5px;
  color: #ffffff;
  background: #00a881;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.1607843137) !important;
}
.bookmark-header form.top_header .css-2b097c-container .css-26l3qy-menu {
  color: #212529;
}
.bookmark-header.chemistry {
  background: #0060ce;
}
.bookmark-header.physics {
  background: #feaf55;
}
.bookmark-header.botany {
  background: #3d8815;
}
.bookmark-header.zoology {
  background: #C37800;
}
.bookmark-header.maths {
  background: #707070;
}

.bookmarks_videos {
  position: relative;
}
.bookmarks_videos a {
  text-decoration: none;
  color: #212529;
}
.bookmarks_videos .card {
  overflow: hidden;
  border-radius: 6px;
}
.bookmarks_videos .card .bg-blur {
  background: hsla(0, 0%, 0%, 0.5) !important;
}
.bookmarks_videos .card .content {
  position: absolute;
  background: hsla(0, 0%, 100%, 0.5);
  width: 100%;
  bottom: 0;
  left: 0;
}
.bookmarks_videos .card .content .card-title {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}
.bookmarks_videos .card .content .d-flex .videodurations {
  padding: 2px 4px;
  background: hsla(0, 0%, 0%, 0.4);
  border-radius: 6px 0;
}

.bookmark_shortNote_materials .bookmark_shortNotes_navs .nav-item .nav-link {
  color: #121412;
  font-weight: 400;
  padding: 0.5rem 1rem 1rem;
}
.bookmark_shortNote_materials .bookmark_shortNotes_navs .nav-item .nav-link.active {
  font-weight: 600;
  color: #007bff;
}
.bookmark_shortNote_materials .section-description .breadcrumb-content .breadcrumb {
  background: transparent !important;
}
.bookmark_shortNote_materials .shortnote_cards {
  margin: 0;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list {
  margin-bottom: 20px;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list:last-child {
  margin-bottom: 0;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list a {
  text-decoration: none;
  color: #121412;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .card-body {
  overflow: hidden;
  position: relative;
  height: 90px;
  margin-bottom: 15px;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card.fullView .card-body {
  height: 100%;
}
.bookmark_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5098039216);
}
.bookmark_shortNote_materials .material_cards .single_material_list {
  position: relative;
  margin-bottom: 20px;
}
.bookmark_shortNote_materials .material_cards .single_material_list:last-child {
  margin-bottom: 0;
}
.bookmark_shortNote_materials .material_cards .single_material_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5098039216);
}
.bookmark_shortNote_materials #filter-popover.popover {
  max-width: 300px !important;
}
@media (max-width: 991px) {
  .bookmark_shortNote_materials #filter-popover.popover .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .bookmark_shortNote_materials #filter-popover.popover .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .bookmark_shortNote_materials #filter-popover.popover .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body {
  padding: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs {
  background: #f8f9fa;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item {
  margin-bottom: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item .nav-link {
  border: none;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link {
  font-weight: 500;
  border: none;
  color: #495057;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link.active,
.bookmark_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  color: #121412;
  background-color: #f8f9fa;
  border-bottom: 2px solid #3ac555;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content {
  padding: 0.5rem 0.5rem 0;
  max-height: 130px;
  overflow-y: scroll;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li {
  margin-bottom: 6px;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li:not(:last-child) {
  margin-right: 0;
}
.bookmark_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li .text {
  width: 250px;
  line-height: 20px;
}

.practice_questions {
  position: relative;
}
.practice_questions .questions-list li {
  margin-bottom: 10px;
  padding: 0;
}
.practice_questions .questions-list li:last-child {
  margin-bottom: 0;
}
.practice_questions .questions-list li a {
  position: relative;
  text-decoration: none;
  color: #212529;
}
.practice_questions .questions-list li a .single_question {
  margin-right: 10px;
}
.practice_questions .questions-list li a:hover {
  background-color: #ffffff;
}
.practice_questions .questions-list li a.active .single_question {
  margin-right: 0px;
}
@media (max-width: 991px) {
  .practice_questions .questions-list li a.active .single_question {
    margin-right: 10px;
  }
}
.practice_questions .questions-list li .single_question .srNo {
  font-size: 14px;
  padding: 0.6rem;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dfdfdf;
  color: #3ac555;
  margin-right: 10px;
}
.practice_questions .questions-list li .single_question .question-content {
  height: 50px;
  overflow: hidden;
}

.page-indication .nav .nav-item {
  margin-right: 4px;
}
.page-indication .nav .nav-item:last-child {
  margin-right: 0;
}
.page-indication .nav .nav-item:nth-child(1) .nav-link.active {
  color: #ffffff;
  background: hsl(211, 100%, 50%);
  border: 1px solid hsla(211, 100%, 50%, 0.6);
}
.page-indication .nav .nav-item:nth-child(2) .nav-link.active {
  color: #ffffff;
  background: hsl(134, 61%, 41%);
  border: 1px solid hsla(134, 61%, 41%, 0.6);
}
.page-indication .nav .nav-item:nth-child(3) .nav-link.active {
  color: #ffffff;
  background: hsl(45, 100%, 51%);
  border: 1px solid hsla(45, 100%, 51%, 0.6);
}
.page-indication .nav .nav-item:nth-child(4) .nav-link.active {
  color: #ffffff;
  background: hsl(354, 70%, 54%);
  border: 1px solid hsla(354, 70%, 54%, 0.6);
}
.page-indication .nav .nav-item .nav-link {
  color: #121412;
  border-radius: 1.5rem;
  border: 1px solid #dfe0e1;
  padding: 0.5rem 1rem;
  transition: 0.3s all;
}

.sr-tags-list {
  position: relative;
}
.sr-tags-list li {
  font-size: 12px;
  padding: 0.1rem 1rem;
  margin-bottom: 10px;
  border-radius: 30px;
  background: #e0e0e0;
}
.sr-tags-list li:not(:last-child) {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/bookmarks/_bookmark.scss"],"names":[],"mappings":"AAAA;EACI,yDAAA;AACJ;;AAEA;EACI,yDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAQgB;EACI,eAAA;AALpB;AAQgB;EACI,eAAA;AANpB;AAWgB;EACI,eAAA;AATpB;AAeI;EACI,qBAAA;AAbR;AAeQ;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAbZ;AAeY;EACI,gCAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAbhB;AAgBY;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;AAdhB;AAiBY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;AAfhB;AAiBgB;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;AAhBpB;AAkBoB;EACI,YAAA;AAhBxB;AAuBI;EACI,SAAA;EACA,UAAA;AArBR;AAuBQ;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AArBZ;AAuBY;EACI,cAAA;EACA,qBAAA;AArBhB;;AA2BA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,+DAAA;AAxBJ;AA4BQ;EACI,cAAA;AA1BZ;AA8BI;EACI,mBAAA;AA5BR;AA+BI;EACI,mBAAA;AA7BR;AAgCI;EACI,mBAAA;AA9BR;AAiCI;EACI,mBAAA;AA/BR;AAkCI;EACI,mBAAA;AAhCR;;AAoCA;EACI,kBAAA;AAjCJ;AAmCI;EACI,qBAAA;EACA,cAAA;AAjCR;AAoCI;EACI,gBAAA;EACA,kBAAA;AAlCR;AAoCQ;EACI,2CAAA;AAlCZ;AAqCQ;EACI,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AAnCZ;AAqCY;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAnChB;AAsCY;EACI,gBAAA;EACA,gCAAA;EACA,oBAAA;AApChB;;AA8CQ;EACI,cAAA;EACA,gBAAA;EACA,yBAAA;AA3CZ;AA6CY;EACI,gBAAA;EACA,cAAA;AA3ChB;AAoDY;EACI,kCAAA;AAlDhB;AAuDI;EACI,SAAA;AArDR;AAuDQ;EACI,mBAAA;AArDZ;AAuDY;EACI,gBAAA;AArDhB;AAwDY;EACI,qBAAA;EACA,cAAA;AAtDhB;AA0DgB;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAxDpB;AA4DoB;EACI,YAAA;AA1DxB;AA8DgB;EACI,eAAA;EACA,kCAAA;AA5DpB;AAkEI;EACI,kBAAA;EACA,mBAAA;AAhER;AAkEQ;EACI,gBAAA;AAhEZ;AAoEY;EACI,eAAA;EACA,kCAAA;AAlEhB;AAuEI;EACI,2BAAA;AArER;AAuEQ;EACI;IACI,sDAAA;EArEd;AACF;AAwEQ;EACI;IACI,aAAA;IACA,sBAAA;EAtEd;EAwEc;IACI,uBAAA;IACA,mBAAA;EAtElB;AACF;AA0EQ;EACI,UAAA;AAxEZ;AA0EY;EACI,mBAAA;EACA,+BAAA;EACA,gCAAA;AAxEhB;AA2EY;EACI,gBAAA;AAzEhB;AA2EgB;EACI,YAAA;AAzEpB;AA6EY;EACI,gBAAA;EACA,YAAA;EACA,cAAA;AA3EhB;AA8EY;;EAEI,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;AA5EhB;AA+EY;EACI,wBAAA;EACA,iBAAA;EACA,kBAAA;AA7EhB;AA+EgB;EACI,kBAAA;AA7EpB;AA+EoB;EACI,eAAA;AA7ExB;AAgFoB;EACI,YAAA;EACA,iBAAA;AA9ExB;;AAsFA;EACI,kBAAA;AAnFJ;AAqFI;EACI,mBAAA;EACA,UAAA;AAnFR;AAqFQ;EACI,gBAAA;AAnFZ;AAsFQ;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;AApFZ;AAsFY;EACI,kBAAA;AApFhB;AAuFY;EACI,yBAAA;AArFhB;AAyFgB;EACI,iBAAA;AAvFpB;AA2FY;EAEQ;IACI,kBAAA;EA1FtB;AACF;AAgGY;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AA9FhB;AAiGY;EACI,YAAA;EACA,gBAAA;AA/FhB;;AAuGI;EACI,iBAAA;AApGR;AAsGQ;EACI,eAAA;AApGZ;AAuGQ;EACI,cAAA;EACA,+BAAA;EACA,2CAAA;AArGZ;AAwGU;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAtGZ;AAyGU;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAvGZ;AA0GU;EACE,cAAA;EACA,8BAAA;EACA,0CAAA;AAxGZ;AA2GU;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,oBAAA;AAzGZ;;AA6GA;EACI,kBAAA;AA1GJ;AA2GK;EACC,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAzGN;AA0GM;EACE,oBAAA;AAxGR","sourcesContent":[".physics_img {\n    background-image: url('../../../images/physics.png');\n}\n\n.chemistry_img {\n    background-image: url('../../../images/chemistry.png');\n}\n\n.zoology_img {\n    background: url('../../../images/zoology.png');\n}\n\n.botnay_img {\n    background: url('../../../images/botnay.png');\n}\n\n.maths_img {\n    background: url('../../../images/maths.png');\n}\n\n\n\n.bookmarks_section {\n    .type-wise-list {\n        .signle_card {\n            .card-header {\n                .icon i {\n                    font-size: 2rem;\n                }\n\n                .card-title {\n                    font-size: 1rem;\n                }\n            }\n\n            .card-body {\n                .card-title {\n                    font-size: 2rem;\n                }\n            }\n        }\n    }\n\n    a {\n        text-decoration: none;\n\n        .singlecard {\n            height: 80px;\n            position: relative;\n            border-radius: 6px;\n            overflow: hidden;\n            flex-direction: row;\n            margin-bottom: 1rem;\n\n            &::before {\n                background: hsla(0, 0%, 0%, 0.6);\n                left: 0;\n                top: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                position: absolute;\n                z-index: 1;\n            }\n\n            .bg-img {\n                left: 0;\n                top: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                position: absolute;\n                z-index: 1;\n                background-size: cover;\n                background-position: top center;\n                background-repeat: no-repeat;\n                filter: blur(2px);\n            }\n\n            .content {\n                color: #ffffff;\n                position: relative;\n                z-index: 2;\n\n                .icon {\n                    text-align: center;\n                    display: block;\n                    line-height: 60px;\n                    width: 60px;\n                    height: 60px;\n                    border-radius: 4px;\n                    // background: hsla(0, 0%, 0%, 0.7);\n                    color: #ffffff;\n\n                    svg {\n                        height: 45px;\n                    }\n                }\n            }\n        }\n    }\n\n    .tags-list {\n        margin: 0;\n        padding: 0;\n\n        li {\n            font-size: 13px;\n            padding: .2rem 1rem;\n            margin-bottom: 10px;\n            border-radius: 30px;\n            background: #e0e0e0;\n\n            a {\n                color: #212529;\n                text-decoration: none;\n            }\n        }\n    }\n}\n\n.bookmark-header {\n    position: relative;\n    padding: 25px 0 5px;\n    color: #ffffff;\n    background: #00a881;\n    box-shadow: 0px 3px 16px #00000029 !important;\n\n    form.top_header .css-2b097c-container {\n\n        .css-26l3qy-menu {\n            color: #212529;\n        }\n    }\n\n    &.chemistry {\n        background: #0060ce;\n    }\n\n    &.physics {\n        background: #feaf55\n    }\n\n    &.botany {\n        background: #3d8815;\n    }\n\n    &.zoology {\n        background: #C37800;\n    }\n\n    &.maths {\n        background: #707070;\n    }\n}\n\n.bookmarks_videos {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #212529;\n    }\n\n    .card {\n        overflow: hidden;\n        border-radius: 6px;\n\n        .bg-blur {\n            background: hsla(0, 0%, 0%, 0.5) !important;\n        }\n\n        .content {\n            position: absolute;\n            background: hsla(0, 0%, 100%, 0.5);\n            width: 100%;\n            bottom: 0;\n            left: 0;\n\n            .card-title {\n                font-size: 15px;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                margin-bottom: 0;\n            }\n\n            .d-flex .videodurations {\n                padding: 2px 4px;\n                background: hsla(0, 0%, 0%, 0.4);\n                border-radius: 6px 0;\n            }\n        }\n    }\n}\n\n\n\n.bookmark_shortNote_materials {\n    .bookmark_shortNotes_navs {\n        .nav-item .nav-link {\n            color: #121412;\n            font-weight: 400;\n            padding: 0.5rem 1rem 1rem;\n\n            &.active {\n                font-weight: 600;\n                color: #007bff\n            }\n        }\n    }\n\n    .section-description {\n        // background-color: #e9ecef;\n\n        .breadcrumb-content {\n            .breadcrumb {\n                background: transparent !important;\n            }\n        }\n    }\n\n    .shortnote_cards {\n        margin: 0;\n\n        li.single_shortnote_list {\n            margin-bottom: 20px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            a {\n                text-decoration: none;\n                color: #121412;\n            }\n\n            .single_card {\n                .card-body {\n                    overflow: hidden;\n                    position: relative;\n                    height: 90px;\n                    margin-bottom: 15px;\n                }\n\n                &.fullView {\n                    .card-body {\n                        height: 100%;\n                    }\n                }\n\n                .helpTags li.list-inline-item {\n                    cursor: pointer;\n                    color: #00000082;\n                }\n            }\n        }\n    }\n\n    .material_cards .single_material_list {\n        position: relative;\n        margin-bottom: 20px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .single_card {\n            .helpTags li.list-inline-item {\n                cursor: pointer;\n                color: #00000082;\n            }\n        }\n    }\n\n    #filter-popover.popover {\n        max-width: 300px !important;\n\n        @media (max-width: 991px) {\n            .card-group .card+.card {\n                border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n\n        .popover-body {\n            padding: 0;\n\n            .nav-tabs {\n                background: #f8f9fa;\n                border-top-left-radius: 0.25rem;\n                border-top-right-radius: 0.25rem;\n            }\n\n            .nav-tabs .nav-item {\n                margin-bottom: 0;\n\n                .nav-link {\n                    border: none;\n                }\n            }\n\n            .nav-tabs .nav-link {\n                font-weight: 500;\n                border: none;\n                color: #495057;\n            }\n\n            .nav-tabs .nav-link.active,\n            .nav-tabs .nav-item.show .nav-link {\n                font-weight: 600;\n                color: #121412;\n                background-color: #f8f9fa;\n                border-bottom: 2px solid #3ac555;\n            }\n\n            .tab-content {\n                padding: 0.5rem 0.5rem 0;\n                max-height: 130px;\n                overflow-y: scroll;\n\n                .custom-list li {\n                    margin-bottom: 6px;\n\n                    &:not(:last-child) {\n                        margin-right: 0;\n                    }\n\n                    .text {\n                        width: 250px;\n                        line-height: 20px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.practice_questions {\n    position: relative;\n\n    .questions-list li {\n        margin-bottom: 10px;\n        padding: 0;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        a {\n            position: relative;\n            text-decoration: none;\n            color: #212529;\n\n            .single_question {\n                margin-right: 10px;\n            }\n\n            &:hover {\n                background-color: #ffffff;\n            }\n\n            &.active {\n                .single_question {\n                    margin-right: 0px;\n                }\n            }\n\n            @media (max-width: 991px) {\n                &.active {\n                    .single_question {\n                        margin-right: 10px;\n                    }\n                }\n            }\n        }\n\n        .single_question {\n            .srNo {\n                font-size: 14px;\n                padding: 0.6rem;\n                border-radius: 4px;\n                text-align: center;\n                border: 1px solid #dfdfdf;\n                color: #3ac555;\n                margin-right: 10px;\n            }\n\n            .question-content {\n                height: 50px;\n                overflow: hidden;\n            }\n        }\n    }\n}\n\n\n.page-indication {\n    .nav .nav-item {\n        margin-right: 4px;\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        &:nth-child(1) .nav-link.active {\n            color: #ffffff;\n            background: hsla(211, 100%, 50%, 1);\n            border: 1px solid hsla(211, 100%, 50%, 0.6);\n          }\n      \n          &:nth-child(2) .nav-link.active {\n            color: #ffffff;\n            background: hsla(134, 61%, 41%, 1);\n            border: 1px solid hsla(134, 61%, 41%, 0.6);\n          }\n      \n          &:nth-child(3) .nav-link.active {\n            color: #ffffff;\n            background: hsla(45, 100%, 51%, 1);\n            border: 1px solid hsla(45, 100%, 51%, 0.6);\n          }\n      \n          &:nth-child(4) .nav-link.active {\n            color: #ffffff;\n            background: hsla(354, 70%, 54%, 1);\n            border: 1px solid hsla(354, 70%, 54%, 0.6);\n          }\n      \n          .nav-link {\n            color: #121412;\n            border-radius: 1.5rem;\n            border: 1px solid #dfe0e1;\n            padding: 0.5rem 1rem;\n            transition: 0.3s all;\n          }\n    }\n}\n.sr-tags-list {\n    position: relative;\n     li {\n      font-size: 12px;\n      padding: 0.1rem 1rem;\n      margin-bottom: 10px;\n      border-radius: 30px;\n      background: #e0e0e0;\n      &:not(:last-child) {\n        margin-right: 0.5rem;\n    }\n  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
